import { render, staticRenderFns } from "./rejectTicket.vue?vue&type=template&id=006e179e&lang=pug"
import script from "./rejectTicket.vue?vue&type=script&lang=js"
export * from "./rejectTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports